import { HttpClient } from "@angular/common/http";
import { ExternalExpr } from "@angular/compiler";
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  DwGridEvents,
  DwGridEventType,
  DwSectionBaseComponent,
  DwComponent,
  DwExpressionService,
  DwGridEvent,
  DwComponentType,
  DwPageBaseComponent,
  DwComponentSectionConfigPreference,
  DwUiConfigRegistryService,
  DwUIMetaDataConfig,
  DwUIMetaDataConfigToken,
  DwMetaDataService,
  DwMetaDataServiceToken,
  DwMdAttribute,
  DwQueryMdAttribute,
  DwEventService,
  DwGridSelectedViewEvent,
  DwSecurityUserService,
} from "@devwareapps/devware-cap";
import { PowerBiGridConfigComponent } from "./power-bi-grid-config/power-bi-grid-config.component";
import * as pbi from "powerbi-client";
import { ConfigService } from "src/environments/environment";
import { Report } from "powerbi-client";
import { Subject } from "rxjs";
import { throttleTime } from "rxjs/operators";
import { PowerBiGridConfig } from "./models/power-bi-grid-config";
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@DwComponent({
  name: "PowerBiGrid",
  isGlobal: true,
  componentType: DwComponentType.pageComponent,
  configComponent: PowerBiGridConfigComponent,
})
@Component({
  selector: "app-power-bi-grid",
  templateUrl: "./power-bi-grid.component.html",
  styleUrls: ["./power-bi-grid.component.scss"],
})
export class PowerBiGridComponent implements OnInit, DwPageBaseComponent<PowerBiGridConfig>
 {
  @ViewChild("reportContainer") reportContainer: ElementRef;
  service: DwEventService;
  viewChangeEvent: DwGridSelectedViewEvent;
  config: pbi.models.IEmbedConfigurationBase;
  report: any;
  reportReloadQueue: number = 0;
  waitSubject = new Subject();
  basicFilter: any[] = [];
  reportId: any;
  powerBiConfig: PowerBiGridConfig;
  workspaceId: any;
  filters: any;
  accessToken: any;
  passGridEvents: any;
  passUserId: boolean;
  tables: string[];
  userId: any;
  pageConfig: PowerBiGridConfig;
  height: number;
  style: string;
  constructor(
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    dwExpressionService: DwExpressionService,
    dwEventService: DwEventService,
    private securityService: DwSecurityUserService,
    private http: HttpClient
  ) {
    this.service = dwEventService;
  }

  ngOnInit(): void {
    this.powerBiConfig = this.pageConfig;
    this.reportId = this.powerBiConfig.reportId;
    this.workspaceId = this.powerBiConfig.workspaceId;
    this.passGridEvents = this.powerBiConfig.passGridEvents;
    this.passUserId = this.powerBiConfig.passUserId;
    this.tables = this.powerBiConfig.tableNames.split(';');
    this.height = this.powerBiConfig.height;
    this.style = 'height:'+ this.height + 'px' + ';width: 100%;border: none;';
    //    this.filters = this.powerBiConfig.filters;
    //    this.filtersContext = this.powerBiConfig.filtersContext;
    var x = this.getToken(this.reportId, this.workspaceId);
    this.service
      .getEventData<DwGridSelectedViewEvent>(DwGridEvents.selectedViewChange)
      .subscribe((viewChangeEvent) => {
        this.viewChangeEvent = viewChangeEvent;
        this.setFilters(this.reportId, this.accessToken);
      });
    x.subscribe((y: any) => {
      this.showReport(y.token, this.reportId)
      this.accessToken = y.token;
    });
    this.securityService.securityContext.ApplicationUser.ExtendedAttributes.forEach(Att => {
      if (Att.AttrName == "TrustUserId"){
        this.userId = Att.AttrValue;
        this.setFilters(this.reportId, this.accessToken);
      }
    });
  }

  getToken(reportId, workspaceId) {
    // return this.http.get(
    //   ConfigService.config.wAppsApi +
    //     "api/PowerBiEmbededToken?reportId=" +
    //     reportId +
    //     "&WorkSpaceId=" +
    //     workspaceId
    // );
    const url: string = ConfigService.config.apiRoot + "/powerbi/token?reportId=";
    return this.http.get(url + reportId + "&WorkSpaceId=" + workspaceId);
  }

  showReport(accessToken, reportID) {
    const reportContainer = this.reportContainer.nativeElement;
    const powerbi = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );
    //    var report = powerbi.embed();
    this.createConfig(reportID, accessToken);
    this.report = <Report>powerbi.embed(reportContainer, this.config);

    this.waitSubject.pipe(throttleTime(50)).subscribe(() => {
      this.setFilters(reportID, accessToken);
      this.report.reload();
    });
  }

  setFilters(reportID: any, accessToken: any) {
    this.basicFilter = [];
    if (this.passGridEvents && this.viewChangeEvent != null){
      this.tables.forEach(table => {
        this.basicFilter.push( {
          $schema: "http://powerbi.com/product/schema#basic",
          target: {
            table: table,
            column: "ViewKey"
          },
          operator: "In",
          values: [this.viewChangeEvent.selectedViewKey],
          filterType: 1 // pbi.models.FilterType.BasicFilter
        })
      })
    }
    if(this.passUserId){
      this.tables.forEach(table => {
      this.basicFilter.push( {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: table,
          column: "UserId"
        },
        operator: "In",
        values: [this.userId],
        filterType: 1 // pbi.models.FilterType.BasicFilter
      })
    })
    }
    this.createConfig(reportID, accessToken);
  }

  createConfig(reportID, accessToken) {
    // Embed URL
    var isDev = ConfigService.config.production;
    const embedUrl = "https://app.powerbi.com/reportEmbed";
    let config: any = {
      type: "report",
      id: reportID,
      embedUrl: "https://app.powerbi.com/reportEmbed",
      tokenType: pbi.models.TokenType.Embed,
      accessToken: accessToken,
      settings: {
        filterPaneEnabled: true,
        background: pbi.models.BackgroundType.Transparent,
        navContentPaneEnabled: false,
      },
      filters: this.basicFilter,
    };
    this.config = config;
    if (this.report != null) {
      this.report.config = config;
      this.reloadReport();
    }
  }

  async reloadReport() {
    this.reportReloadQueue++;
    let reportReloadQueueNumber = this.reportReloadQueue;
    await this.delay(1200);
    if (reportReloadQueueNumber == this.reportReloadQueue) {
      this.report.reload();
      console.log("Reloaded Report");
    } else {
      console.log("Did not reload report");
    }
  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
